import React, {useContext, Fragment} from "react";


import UserProfileForm from "../components/ui/form-user-profile.js";
import { useDeleteUser, useUpdateUser, useCreateUser, useGetUsers } from "../api/adminusers.js";
import ListEditComponent from "../components/ui/component-list-edit.js";
import UserEditList from "../components/ui/list-edit-user.js";


import SnackbarContext from "../context/snackbar-context.js";
import { handleDisplayResponseResults } from "../api/api_util.js";

export default function ManageUserPage() {

  const snackbarContext=useContext(SnackbarContext);

  const createUser = useCreateUser();

  const updateUser = useUpdateUser();

  const deleteUser = useDeleteUser();


  const formatCreateSuccess = (result) => `${result.item.userID} was added as a super admin`
  const formatCreateError = (result) => `${result.item.email} could not be added as a super admin`

  const formatUpdateSuccess = (result) => `Super admin ${result.item.userID} was updated`
  const formatUpdateError = (result) => `Super admin ${result.item.userID} could not be updated`

  const formatDeleteSuccess = (result) => `${result.item.userID} was removed as a super admin`
  const formatDeleteError = (result) => `${result.item.userID} could not be removed as a super admin`



  const handleCreate = async (userData) => {

    try {
      const response = await createUser(userData);
      console.log('Create Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatCreateSuccess, formatCreateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };




  const handleUpdate = async (updatedData) => {
    try {

      const response = await updateUser(updatedData);
      console.log('Update Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatUpdateSuccess,formatUpdateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };


  const handleDelete = async (userData) => {
    try {
      const response = await deleteUser(userData);
      handleDisplayResponseResults(response, snackbarContext, formatDeleteSuccess, formatDeleteError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };


  return (
    <Fragment>
    <ListEditComponent editForm={UserProfileForm} objectLabel="Super Admin" editList={UserEditList} useGetList={useGetUsers} createHandler={handleCreate} updateHandler={handleUpdate} deleteHandler={handleDelete} deleteConfirmMessage="Removing a super admin revokes their super-admin rights. If they have no other roles their account is deleted; otherwise the account is kept with those roles intact. At least two super admins must remain." />
    </Fragment>
  );
};